export const configuration = {
  activeSims: null,
  awsSIMS: [],
  awsSentMessages: [],
  awsReceivedMessages: [],
  cancelSource: null,
  cancelSourceWAN: null,
  clearedTimestamp: null,
  connectionLoading: false,
  connectionChanged: false,
  connectionLoadingTimeout: false,
  connections: null,
  popoverVisible: false,
  inactiveSims: null,
  groups: [],
  lastEvaluatedKey: null,
  messageSending: 0,
  modalVisible: false,
  yourSMS: null,
  theirSMS: null,
  senders: null,
  polling: false,
  sendersNumbers: [],
  outgoingMsgs: null,
  messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
  newMessagesCount: 0,
  isChatOpen: false, // to determine whether the chat window should be open or closed
  showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
  colors: {
    header: {
      bg: '#153042',
      text: '#ffffff',
    },
    launcher: {
      bg: '#4e8cff',
    },
    messageList: {
      bg: '#ffffff',
    },
    sentMessage: {
      bg: '#1890ff',
      text: '#ffffff',
    },
    receivedMessage: {
      bg: '#eaeaea',
      text: '#222222',
    },
    userInput: {
      bg: '#f4f7f9',
      text: '#565867',
    },
  },
}
